import service from '@/api/roleGroup';
import {handleError, alert} from '@/state/generators/helpers';

export const state = {
    loadingPermissions: false,
    loading: false,
    permissionTree: [],
    service: service('roleGroups')
}

export const getters = {
    permissionLoading: (state) => {
        return !!state.loadingPermissions;
    },

    permissionTree: (state) => {
        return JSON.parse(JSON.stringify(state.permissionTree))
    },
}

export const mutations = {
    'SET_LOADING_PERMISSIONS': function (state, boolean = true) {
        state.loadingPermissions = boolean;
    },

    'SET_PERMISSION_TREE': function (state, data = []) {
        state.permissionTree = data;
    },
}

// csak a legutóbbi fa-lekérés válasza számít: egy korábbi (más csoport, más alkalmazás) később is megérkezhet
let treeRequest = 0;

export const actions = {
    fetchPermissionTree: ({ commit }, payload) => {
        const {id, params} = typeof payload === 'object' && payload !== null ? payload : {id: payload, params: {}};
        const request = ++treeRequest;

        commit('app/SET_LOADING', true, {root: true})
        commit('SET_LOADING_PERMISSIONS', true)

        return state.service.fetchRoles(id, params).then(response => {
            if (request === treeRequest) {
                commit('SET_PERMISSION_TREE', response.data);
            }
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        }).finally(() => {
            if (request === treeRequest) {
                commit('app/SET_LOADING', false, {root: true})
                commit('SET_LOADING_PERMISSIONS', false)
            }
        });
    },

    saveRoles: function ({commit}, {id, roles}) {
        commit('app/SET_LOADING', true, {root: true})
        commit('SET_LOADING_PERMISSIONS', true)

        return state.service.saveRoles(id, roles).then(response => {
            commit('SET_PERMISSION_TREE', response.data)
            alert(commit, this.$t('request.save_is_successful'))
            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        }).finally(() => {
            commit('app/SET_LOADING', false, {root: true})
            commit('SET_LOADING_PERMISSIONS', false)
        })
    },
}
